import { IframeUtility } from '@inter-ikea-kompis/utilities';
import { Settings } from 'sofa-reborn-react';
import { PlatformService } from '@inter-ikea-kompis/services';

let elementHeight: number | null = null;

export default class IFrameHandler {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	private platformService: any;

	constructor(settings: Settings) {
		this.platformService = new PlatformService({
			applicationName: settings.applicationName,
			localizationPrefixApplication: settings.localizationPrefixApplication,
			localizationEndpoints: settings.localizationEndpoints,
			locale: settings.locale,
		});
	}

	public setIframeHeight(height: number): void {
		this.platformService.setIframeHeight(height);
	}

	public updateIframeHeight(height?: number): void {
		if (IframeUtility.isInsideIframe()) {
			const windowWidth = window.innerWidth;
			const calculatedHeight = IframeUtility.calculateHeight(windowWidth);

			elementHeight = height ? height : elementHeight;
			const newIframeHeight =
				elementHeight && elementHeight > calculatedHeight ? elementHeight : calculatedHeight;

			if (newIframeHeight !== window.innerHeight) {
				this.setIframeHeight(newIframeHeight);
			}
		}
	}

	public resetIframeHeight(): void {
		const calculatedHeight = IframeUtility.calculateHeight(window.innerWidth);
		elementHeight = null;

		this.setIframeHeight(calculatedHeight);
	}
}
